import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { SellersService } from '@services/data-source-tables/sellers.service';
import { SellerModel } from '@/models/tables/seller.model';

@Component({
  selector: 'app-button-seller-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteSellerComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private sellerModel: SellerModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected sellersService: SellersService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.sellerModel = <SellerModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteSeller) => {
      if (deleteSeller) {
        this.sellersService.deleteSeller(this.sellerModel.id).subscribe({
          next: () => {
            this.toastr.success('Venditore cancellato correttamente!');

            Registry.getInstance().get('SellerComponent').loadSellers();
          },
          error: (error) => {
            LoggerService.error('deleteSeller failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione del Venditore.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo Venditore?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata il Venditore non sarà più possibile recuperarlo.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
